import { el } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import HelptapEditor from '../../helpers';

import { stringToSVG } from 'utilities';

import duplicateNodeIconString from 'assets/images/duplicate-node-icon.svg?raw';

const duplicateNodeIcon = stringToSVG(duplicateNodeIconString);

class DuplicateNodeButton {

  constructor(menu, configuration) {

    this.menu = menu;

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;

    this.el = el('button.duplicate-node-button', {
      type: 'button',
      onclick: this.handleButtonClick.bind(this)
    }, [duplicateNodeIcon.cloneNode(true), el('label', 'Duplicate')]);

  }

  handleButtonClick() {

    const editor = this.editor;
    const node = this.node;
    const activeNodePath = this.activeNodePath;

    try {

      HelptapEditor.duplicate.duplicateNode(editor, node, activeNodePath);

    } catch (exception) {

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: exception.message,
        seconds: 5,
        type: 'error'
      });

    } finally {
      this.menu.onClose();
    }

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;
    this.node = { ...configuration.node };

  }

}

export default DuplicateNodeButton;